import { SxProps, Theme } from '@mui/material/styles';

export const customReportRootSx = {
  width: '100%',
};

export const customReportSectionWrapperSx = {
  maxWidth: '100%',
};

export const customReportSectionTitleSx = {
  mb: '16px',
};

export const customReportDataGridSx = (isEdit: boolean) => ({
  width: '100%',
  height: isEdit ? '360px' : 'unset',
  maxWidth: '100%',
  overflowY: 'auto',
});

export const headerButtonsSx: SxProps<Theme> = (theme: Theme) => ({
  '&.MuiButton-outlined': {
    color: theme.palette.text.primary,
    borderColor: theme.palette.report.main,
  },
  '&.MuiButton-contained': {
    background: theme.palette.text.primary,
    '&&:focus:hover': {
      backgroundColor: theme.palette.text.primary,
      color: theme.palette.report.contrastText,
    },
  },
  '&&:focus': {
    boxShadow: 'none',
  },
});

export const customReportHeaderBarSx: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  p: 2,
  mb: 2,
  fontWeight: 500,
});

export const customReportHeaderButtonGroupSx = {
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
};

export const breadcrumbStyles: SxProps<Theme> = {
  pl: 4,
  pb: 0,
};

export const customReportViewHeaderGroupSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '16px',
};

export const editMenuContainerSx = {
  padding: '24px',
  width: '395px',
};

export const editMenuContainerLargeSx = {
  padding: '24px',
  width: '750px',
};

export const draggablePopoverBackdropSx = {
  root: {
    sx: {
      // This is a bit hacky, but the react-draggable library applied to a MUI popover causes the backdrop to
      // also be transformed (dragged), since the default backdrop size is exactly the size of the screen, when
      // dragged it exposes clickable areas that aren't covered by the backdrop. Increasing it's size prevents this.
      '.MuiBackdrop-root': {
        width: '200vw',
        height: '300vh',
        marginTop: '-100vh',
      },
    },
  },
};

export const addSectionButtonSx = (position: 'above' | 'below') => ({
  position: 'sticky',
  top: '0',
  marginTop: position === 'above' ? '0px' : '-19px', // The add section button is 38px tall, and we want the section border to be in the middle
  width: '150px',
  backgroundColor: 'background.paper',
  '&:hover': { backgroundColor: 'background.paper' },
});

export const addSectionButtonContainerSx = (active: boolean) => ({
  // The add section button is 38px tall and the container has 2px borders, so this is half of that (19px) plus the 2px border
  marginBottom: active ? '-21px' : '0',
  marginTop: active ? '-21px' : '0',
  alignItems: 'center',
});

export const editMenuHalfMarginBelow = {
  marginBottom: '16px',
};

export const editMenuMarginBelow = {
  marginBottom: '32px',
};

export const editMenuTitleSx = {
  fontWeight: 600,
  fontSize: '16px',
  marginTop: 2,
};

export const editMenuSubTextSx: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  fontSize: '12px',
  paddingBottom: '10px',
});

export const lastEditedDateBoxSx: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.report.subtleAccent,
  height: '24px',
  width: '24px',
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
});

export const lastEditedDateIconSx: SxProps<Theme> = {
  height: '24px',
  width: '24px',
  color: 'info.dark',
};

export const customReportsMenuButtonSx: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '8px',
});

export const gridContainerSx = {
  marginTop: '16px',
};

export const customReportDataGridOutlineSx: SxProps<Theme> = (theme: Theme) => ({
  outline: '2px solid',
  outlineColor: theme.palette.report.lightAccent,
  padding: '24px 24px 32px 24px',
  // The add section button is 38px tall so this is half that
  marginTop: '-19px',
});

export const customReportDataGridContainerSx = (edit: boolean) => ({
  padding: edit ? '24px 24px 32px 24px' : '0 0 32px 0',
});

export const sectionNameContainerSx: SxProps<Theme> = {
  height: '40px',
};

export const groupingCardSx = {
  backgroundColor: 'background.default',
  p: 2,
  mb: 1,
};

export const dragIconSx: SxProps<Theme> = {
  color: 'text.secondary',
  marginLeft: '-6px',
  marginRight: 1,
};

export const iconSx: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.text.primary,
  fontSize: '20px',
  marginRight: 1,
});

export const errorSx = {
  color: 'error.main',
};

export const filtersFlexGrowSx = { flex: 0.9, minWidth: 0, pt: 3 };
